interface StoredItem<T = any> {
  value: T;
  expiry: number;
}

export function getTrackingValue<T = any>(key: string): T | null {
  if (typeof window === 'undefined') return null;

  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  try {
    const item: StoredItem<T> = JSON.parse(itemStr);

    if (Date.now() > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  } catch {
    return null; // invalid JSON
  }
}

export function getAllByPrefix(prefixes: string[]): Record<string, any> {
  if (typeof window === 'undefined') return {};

  const result: Record<string, any> = {};
  const now = Date.now();

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (!key) continue;

    // Check if key starts with any prefix
    if (prefixes.some((p) => key.startsWith(p))) {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) continue;

      try {
        const item: StoredItem = JSON.parse(itemStr);

        // Remove expired items
        if (item.expiry && now > item.expiry) {
          localStorage.removeItem(key);
          continue;
        }

        result[key] = item.value;
      } catch (err) {
        // Invalid JSON, skip
        continue;
      }
    }
  }

  return result;
}

export function addLocalPrefix<T extends Record<string, any>>(
  data: T,
): Record<string, any> {
  const result: Record<string, any> = {};

  Object.keys(data).forEach((key) => {
    result[`${key}`] = data[key];
  });

  return result;
}

export const metadataFromLocalStorage = () => {
  const metaData = getAllByPrefix(['afc_', 'ref_', 'utm_']);
  const metaDataWithLocalPrefix = addLocalPrefix(metaData);
  if (
    !metaDataWithLocalPrefix ||
    Object.keys(metaDataWithLocalPrefix).length === 0
  ) {
    return null;
  }
  return metaDataWithLocalPrefix;
};
